import { useMemo } from "react";
import { shape, string } from "prop-types";

import { getMapLocationQuery } from "../../../helpers";

const getDirectionsUrl = (location, locationTitle) => {
  if (!location) {
    return null;
  }

  const { locationAddress, locationCity, locationState, locationZip, placeId } =
    location;

  const name = `${locationTitle}${locationCity}`;
  let query =
    getMapLocationQuery(
      locationAddress,
      locationCity,
      name,
      locationState,
      locationZip
    ) || "";

  if (!!placeId) {
    query += `&destination_place_id=${encodeURIComponent(placeId)}`;
  }

  if (!query) {
    return null;
  }

  return `https://www.google.com/maps/dir/?api=1&destination=${query}`;
};

const LocationDirections = ({ location, locationTitle, ...rest }) => {
  const directionsUrl = useMemo(
    () => getDirectionsUrl(location, locationTitle),
    [location, locationTitle]
  );

  return (
    <a {...rest} href={directionsUrl}>
      Get directions on Google Maps
    </a>
  );
};

LocationDirections.propTypes = {
  location: shape({
    locationAddress: string,
    locationCity: string,
    locationState: string,
    locationZip: string,
    placeId: string,
  }),
  locationTitle: string.isRequired,
};

export default LocationDirections;
